import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';
import { Attachment } from './attachment';

@JsonObject('OdvDocuments')
export class OdvDocuments extends Entity {
  @JsonProperty('salesOrderDocumentId', String)
  public salesOrderDocumentId?: string = undefined;

  @JsonProperty('documentId', String)
  public documentId?: string = undefined;

  @JsonProperty('userId', String)
  public userId?: string = undefined;

  @JsonProperty('userName', String)
  public userName?: string = undefined;

  @JsonProperty('uploaded', Boolean)
  public uploaded?: boolean = undefined;

  @JsonProperty('document', Attachment)
  public document?: Attachment = undefined;

  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
}
